import axiosClient, { unwrap } from "./axiosClient";
import { ENDPOINTS } from "./endpoints";

const cleanParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) => value !== undefined && value !== null && value !== ""
    )
  );

export const reportApi = {
  dailySales: (reportDate) =>
    axiosClient
      .get(ENDPOINTS.reports.dailySales, {
        params: {
          reportDate,
        },
      })
      .then(unwrap),

  paymentSummary: (reportDate) =>
    axiosClient
      .get(ENDPOINTS.reports.paymentSummary, {
        params: {
          reportDate,
        },
      })
      .then(unwrap),

  profit: (reportDate) =>
    axiosClient
      .get(ENDPOINTS.reports.profit, {
        params: {
          reportDate,
        },
      })
      .then(unwrap),

  stockSummary: () =>
    axiosClient
      .get(ENDPOINTS.reports.stockSummary)
      .then(unwrap),

  currentStockValue: () =>
    axiosClient
      .get(ENDPOINTS.reports.currentStockValue)
      .then(unwrap),
};

export const auditApi = {
  getAll: () =>
    axiosClient
      .get(ENDPOINTS.audit.list)
      .then(unwrap),
};

export const notificationApi = {
  getRecipients: () =>
    axiosClient
      .get(ENDPOINTS.notifications.recipients)
      .then(unwrap),

  createRecipient: (data) =>
    axiosClient
      .post(ENDPOINTS.notifications.recipients, data)
      .then(unwrap),

  updateRecipient: (id, data) =>
    axiosClient
      .put(ENDPOINTS.notifications.recipientUpdate(id), data)
      .then(unwrap),

  setRecipientStatus: (id, status) =>
    axiosClient
      .patch(ENDPOINTS.notifications.recipientStatus(id), null, {
        params: {
          status,
        },
      })
      .then(unwrap),

  getLogs: (params = {}) =>
    axiosClient
      .get(ENDPOINTS.notifications.logs, {
        params: cleanParams(params),
      })
      .then(unwrap),
};

export const expenseApi = {
  getAll: () =>
    axiosClient
      .get("/api/admin/expenses")
      .then(unwrap),

  create: (data) =>
    axiosClient
      .post("/api/admin/expenses", data)
      .then(unwrap),

  update: (id, data) =>
    axiosClient
      .put(`/api/admin/expenses/${id}`, data)
      .then(unwrap),

  delete: (id) =>
    axiosClient
      .delete(`/api/admin/expenses/${id}`)
      .then(unwrap),

  report: (params) =>
    axiosClient
      .get("/api/admin/reports/expenses", {
        params,
      })
      .then(unwrap),
};